import { useState } from "react";

export default function WhatsAppFloat() {
  const [open, setOpen] = useState(false);

  return (
    <div className="fixed bottom-5 right-5 z-[60] flex flex-col items-end gap-3">
      {/* Balão de mensagem */}
      {open && (
        <div className="bg-white rounded-2xl rounded-br-sm shadow-md border border-gray-100 p-4 max-w-[240px]">
          <p className="text-sm text-gray-800 font-medium leading-snug">
            Olá! 👋 Precisa de ajuda com benefícios ou planos de saúde?
          </p>
          <p className="text-xs text-gray-500 mt-1.5">
            Fale com a gente agora mesmo.
          </p>
        </div>
      )}

      {/* Botão flutuante */}
      <a
        href="https://wa.me/5511936189998"
        target="_blank"
        rel="noopener noreferrer"
        onMouseEnter={() => setOpen(true)}
        onMouseLeave={() => setOpen(false)}
        className="whitespace-nowrap w-14 h-14 flex items-center justify-center rounded-full bg-[#25D366] text-white hover:bg-[#1ebe5d] transition-all duration-200 cursor-pointer"
        aria-label="Falar pelo WhatsApp"
      >
        <i className="ri-whatsapp-line text-2xl" />
      </a>
    </div>
  );
}